import { useHomeBanner, useServiceAIQuizWizard } from '@/src/api/getData';
import Banner from '@/components/banner';
import Video from '@/components/video';
import Card from '@/components/card';

const ITechAiQuizWizardView: any = ({ language = '' }) => {
    const { data: banner } = useHomeBanner(language);
    const { data: quizWizard } = useServiceAIQuizWizard(language);
    let quizWizardData = quizWizard?.data || {};

    let quizWizardHeader = quizWizardData.Step_title || {};
    let videoData = quizWizardData.Video?.[0]?.Video || [];
    let editor = quizWizardData.Table_list || "";

    return (
        <main id="start" className='bg-2' >
            <Banner banner={banner} category="AI Quiz Wizard" />
            <Card cardData={quizWizardData.Cards || []} cardType="orange-card" />
            <section className="stepList container">
                <div className='patten_1'><img src="/images/pattern-2.svg" alt="pattern 2" /></div>
                <div className='center-content'>
                    <div className="title">
                        <h2 dangerouslySetInnerHTML={{ __html: quizWizardHeader.ColorOne }} />
                        <div className="dec" dangerouslySetInnerHTML={{ __html: quizWizardHeader.ColorTwo }} />
                    </div>
                    <div className="steps">
                        {quizWizard?.data?.Step?.map((step: any, index: number) => (
                            <div className="step-item" key={step.id || index}>
                                <div className="step-number">{index + 1}</div>
                                <div className="step-title">{step.Title}</div>
                            </div>
                        ))
                        }
                    </div>
                </div>
                <div className='patten_2'><img src="/images/pattern-3.svg" alt="pattern 3" /></div>
            </section>

            {editor && (
                <section className="gradientCard container">
                    <div className="gradientCard-content">
                        <div className="pattern"></div>
                        <div className="content">
                            <div className='lists lists-v2' dangerouslySetInnerHTML={{ __html: editor }}></div>
                        </div>
                    </div>
                </section>
            )}
            <Video videoData={videoData} />
        </main>
    );
}

export default ITechAiQuizWizardView;